module.exports = __webpack_public_path__ + "static/media/Background_2.c4bcec5d.jpg";